import React, { useState, useEffect, useRef } from 'react';
import { Stack } from '@mui/material';
import './presto.css';
import { getDecodedToken, getSector } from '../../service/service';
import PrestoCriticalIssuesIcon from '../../assets/Critical_Issues.svg';
import UnderDevelopment from '../../assets/under-construction.svg';

const criticalIssues = () => {
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const dataFetchedRef = useRef(false);
	const [, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			setSectorOptionsList(sectorRes.data.sector.map((x: any) => x.name));
		}
	}
	useEffect(() => {
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;

		if (userSector === 'all') fetchSectorOptionsData();
		let storedSectorFilter = localStorage.getItem('presto-summary-sector-filter')
			? JSON.parse(localStorage.getItem('presto-summary-sector-filter') ?? '')
			: null;
		if (storedSectorFilter) {
			setCheckedList(storedSectorFilter);
			setCurrSectorFilter(storedSectorFilter);
		}
	}, [userSector]);
	return (

		<div className="presto-summary-panel">
			<Stack>
				<span className="presto-model-menu">
					<img src={PrestoCriticalIssuesIcon} className="presto-icon" />
					<span className="presto-header-name">Critical Issues</span>
				</span>
			</Stack>
			<div className='under-development-container'>
				<img src={UnderDevelopment} alt="Under development" />
				<p className='under-development-text'>Dashboard under development!</p>
			</div>
		</div>
	);
};

export default criticalIssues;
